<template>
  <form @submit.prevent>
    <!-- 氏名 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name"
      >
        氏名
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name"
              v-model="lastName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="煌木"
              type="text"
              required
            >
            <span
              v-if="errors.last_name && errors.last_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="太郎"
              type="text"
              required
            >
            <span
              v-if="errors.first_name && errors.first_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 氏名（カナ） -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name_kana"
      >
        氏名（カナ）
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name_kana"
              v-model="lastNameKana"
              placeholder="キラメキ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name_kana.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstNameKana"
              placeholder="タロウ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.first_name_kana.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- メールアドレス -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_email"
      >
        メールアドレス
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <input
          id="entry_email"
          v-model="email"
          placeholder="taro.kirameki@techacademy.jp"
          type="email"
          required
          class="input w-full border-2 border-co-gray-300"
        >
        <span
          v-if="errors.email && errors.email.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.email.join(', ') }}
        </span>
      </div>
    </div>
    <!-- 電話番号 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_tel"
      >
        電話番号
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <input
          id="entry_tel"
          v-model="tel"
          placeholder="09012345678（ハイフン不要）"
          type="tel"
          required
          class="input w-full border-2 border-co-gray-300"
        >
        <span
          v-if="errors.tel && errors.tel.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.tel.join(', ') }}
        </span>
      </div>
    </div>
    <!-- 性別 -->
    <div class="flex flex-col items-baseline border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_sex"
      >
        性別
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="flex basis-full flex-col items-baseline md:basis-8/12">
        <div
          id="entry_sex"
          class="flex gap-x-4"
        >
          <div
            v-for="(option, index) in radioOptions"
            :key="index"
            class="form-control"
          >
            <label class="cursor-pointer">
              <input
                v-model="radioSelected"
                type="radio"
                :value="option.value"
                name="radio-options"
                required
                class="radio"
              >
              <span class="ml-2">{{ option.text }}</span>
            </label>
          </div>
        </div>
        <span
          v-if="errors.sex && errors.sex.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.sex.join(", ") }}
        </span>
      </div>
    </div>
    <!-- 生年月日 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_birthday"
      >
        生年月日
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-1">
          <select
            id="entry_birthday"
            v-model="birthdayYearSelected"
            class="select w-auto border-2 border-co-gray-300"
            required
          >
            <option
              v-for="(option, index) in birthdayYearOptions"
              :key="index"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
          <select
            v-model="birthdayMonthSelected"
            class="select w-auto border-2 border-co-gray-300"
            required
          >
            <option
              v-for="(option, index) in birthdayMonthOptions"
              :key="index"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
          <select
            v-model="birthdayDaySelected"
            class="select w-auto border-2 border-co-gray-300"
            required
          >
            <option
              v-for="(option, index) in birthdayDayOptions"
              :key="index"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
          <span
            v-if="errors.birthday && errors.birthday.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.birthday.join(', ') }}
          </span>
        </div>
      </div>
    </div>
    <!-- ボタン -->
    <div class="flex flex-col justify-end pb-5 pt-4 md:flex-row">
      <div class="basis-full md:ml-auto md:basis-8/12 md:pl-6">
        <span
          v-if="Object.keys(errors).length !== 0"
          class="te-invalid-feedback inline-block py-2"
        >
          入力いただいた情報に誤りまたは不足があるようです。
        </span>
        <span
          v-if="applicationErrors.length !== 0"
          class="te-invalid-feedback inline-block py-2"
        >
          {{ applicationErrors[0] }}
        </span>
        <!-- 申し込み内容を確認するボタン -->
        <button
          class="co-btn-submit-stretch"
          @click="onSubmit"
        >
          申し込む
        </button>
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { postJobsCandidateEntry } from '~/utility/fetchAPI'
import { yearOptions, monthOptions, dayOptions } from '~/utility/utility'
import validateJobsCandidateForm from '~/utility/validation/validateJobsCandidateForm'

import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'

interface TextValue {
  value: string
  text: string
}

interface Data {
  email: string
  lastName: string
  lastNameKana: string
  firstName: string
  firstNameKana: string
  radioSelected: string
  tel: string
  birthday: string
  birthdayYearSelected: string
  birthdayYearOptions: TextValue[]
  birthdayMonthSelected: string
  birthdayMonthOptions: TextValue[]
  birthdayDaySelected: string
  birthdayDayOptions: TextValue[]
  errors: any
  applicationErrors: string[]
}

interface Methods {
  onSubmit: () => void
}

interface Props {
  courseNamePath: string
}

const options = {
  data() {
    return {
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      email: '',
      tel: '',
      birthday: '',
      remarks: '',
      birthdayYearSelected: '1991',
      birthdayYearOptions: yearOptions,
      birthdayMonthSelected: '5',
      birthdayMonthOptions: monthOptions,
      birthdayDaySelected: '27',
      birthdayDayOptions: dayOptions,
      radioSelected: '',
      radioOptions: [
        { text: '男性', value: '0' },
        { text: '女性', value: '1' },
        { text: '無回答', value: '2' },
        { text: 'その他', value: '99' },
      ],
      errors: {},
      applicationErrors: [],
    }
  },
  props: {
    courseNamePath: {
      type: String,
    },
  },
  mounted() {},
  computed: {},
  methods: {
    onSubmit() {
      const body: any = {
        candidate: {
          email: this.email,
          last_name: this.lastName,
          last_name_kana: this.lastNameKana,
          first_name: this.firstName,
          first_name_kana: this.firstNameKana,
          tel: this.tel,
          sex: this.radioSelected,
          birthday: `${this.birthdayYearSelected}-${this.birthdayMonthSelected}-${this.birthdayDaySelected}`,
        },
      }
      validateJobsCandidateForm(body)
        .then(() => {
          postJobsCandidateEntry(this.$api, this.courseNamePath, body)
            .then((body) => {
              window.location.href = `${body.redirect_to}`
            })
            .catch((errors: any) => {
              this.applicationErrors = errors?.response?.data?.errors
            })
        })
        .catch((errors: any) => {
          this.errors = errors
        })
    },
  },
  components: {
    TeCommonBadgeRequired,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
